import React from "react";
import { StyleSheet, View } from "react-native";

const Index = () => {
  return (
    <View style={styles.closequotes}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="55"
        height="48"
        viewBox="0 0 55 48"
      >
        <g fill="none" fill-rule="evenodd">
          <g style={{ fill: "var(--module-color-atr)" }} fill-rule="nonzero">
            <path
              d="M45.792 24v8.635l-.294.091c-5.252 1.686-7.878 6.272-7.878 13.757v2.49h8.172V72H24V54.574l.002-.569c.144-18.668 7.407-28.67 21.79-30.005zM79 24v8.635l-.294.091c-5.252 1.686-7.878 6.272-7.878 13.757v2.49H79V72H57.208V54.574l.002-.569C57.354 35.337 64.617 25.335 79 24z"
              transform="translate(-48 -210) translate(24 186)"
            />
          </g>
        </g>
      </svg>
    </View>
  );
};

export default Index;

const styles = StyleSheet.create({
  closequotes: {
    height: 46.5,
    width: 55,
    bottom: 10.5,
    left: 19,
  },
});
